import React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

const Pagination = ({
  currentPage,
  totalPages,
  totalItems,
  itemsPerPage,
  onPageChange,
  startIndex,
}) => {
  return (
    <div className="bg-slate-50 px-6 py-4 border-t border-slate-200 rounded-b-xl flex flex-col sm:flex-row items-center justify-between gap-4 border-l border-r border-b">
      <div className="text-sm text-slate-500">
        Hiển thị{" "}
        <span className="font-semibold text-slate-900">
          {totalItems > 0 ? startIndex + 1 : 0} -{" "}
          {Math.min(startIndex + itemsPerPage, totalItems)}
        </span>{" "}
        trong tổng số{" "}
        <span className="font-semibold text-slate-900">{totalItems}</span> kết quả
      </div>
      <div className="flex gap-2">
        <button
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
          className="px-3 py-1.5 border border-slate-300 rounded text-sm bg-white text-slate-500 hover:bg-slate-50 disabled:opacity-50 disabled:hover:bg-white font-medium flex items-center gap-1 transition-colors"
        >
          <ChevronLeft size={14} /> Trước
        </button>

        <div className="hidden sm:flex gap-1">
          {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
            let pageNum = i + 1;
            if (totalPages > 5 && currentPage > 3) {
              pageNum = currentPage - 2 + i;
              if (pageNum > totalPages) pageNum = totalPages - (4 - i);
            }
            if (pageNum < 1) pageNum = i + 1;

            if (pageNum <= totalPages) {
              return (
                <button
                  key={pageNum}
                  onClick={() => onPageChange(pageNum)}
                  className={`px-3 py-1.5 border rounded text-sm font-medium transition-colors ${
                    currentPage === pageNum
                      ? "border-blue-600 bg-blue-600 text-white"
                      : "border-slate-300 bg-white text-slate-500 hover:bg-slate-50"
                  }`}
                >
                  {pageNum}
                </button>
              );
            }
            return null;
          })}
        </div>

        <button
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages || totalPages === 0}
          className="px-3 py-1.5 border border-slate-300 rounded text-sm bg-white text-slate-500 hover:bg-slate-50 disabled:opacity-50 disabled:hover:bg-white font-medium flex items-center gap-1 transition-colors"
        >
          Sau <ChevronRight size={14} />
        </button>
      </div>
    </div>
  );
};

export default Pagination;